/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
var productCardMarkup = 
  `<div class="swym-wishlist-grid">
		{{#products}} 
	<a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
    <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
      <span class="swym-icon">
      <svg width="21.54" height="20.707" viewBox="0 0 21.54 20.707">
        <g transform="translate(-27.933 -22.646)">
          <line x1="20" y2="20" transform="translate(28.286 23)" fill="none" stroke="#454545" stroke-width="1"/>
          <line x1="19.977" y1="19.977" transform="translate(29.142 23)" fill="none" stroke="#454545" stroke-width="1"/>
        </g>
    </svg>
      </span>
    </button>

		<div class="swym-wishlist-image-wrapper"><img  data-src="{{empi}}" alt="{{dt}}" class="swym-wishlist-image" src="{{iu}}"></div><button class="swym-is-button">
		<div class="swym-title swym-title-1 font-text-pro">
			{{dt}}
		</div></button>
		<div class="swym-product-price swym-text swym-text-1">
			<div class="swym-product-final-price swym-value font-text-pro">
				{{formattedPrice}}<small class="font-gothic">円（税込）</small>
			</div>
        </div>
				{{#available}}{{/available}}{{^available}}
					<button data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}"class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button swym-out-of-stock-button">
						在庫切れ
					</button>
    		{{/available}}
    </a> 
       {{/products}}
	</div>`;



var noItemText = `
	<div class="rte" style="width:100%;text-align:center;">
		<p>現在、お気に入りはありません。</p>
		<a href="/collections/all">買い物を続ける</a>
	</div>
`;

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;

	} catch (err) {
		return variants;
	}
}

function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(async function(products) {
		//console.log(products)
		var wishlistContentsContainer = document.getElementById("wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p) {
      //console.log(p)
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
      return p;
		});
    // CUSTOM FUNCTION
    const addInfoProducts = async (products) => {
      //console.log(products);
      const newProducts = [];
      const formatter = new Intl.NumberFormat('ja-JP'); //format price
      for (const product of products) {
				try {
					//console.log(product)
					const handlizedProduct = shopifyHandleize(product.dt);
					//console.log(handlizedProduct)
					// fetch product with Shopify product API
					const res = await fetch(window.Shopify.routes.root + `products/${handlizedProduct}.js`);

					if (res.status == "200") {
						const data = await res.json();
						//console.log(data);
						// add product info
						newProducts.push({...product, available: data.available, formattedPrice: formatter.format(Number(data.price / 100)) });
					}
				} catch(error) {
					console.error("Error", error);
				}
      }
      return newProducts;
    }
    //console.log(addInfoProducts(formattedWishlistedProducts));

		const fetchedProducts = await addInfoProducts(formattedWishlistedProducts);
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: fetchedProducts
		});
		if(wishlistContentsContainer){
			//console.log(fetchedProducts);
			//console.log(fetchedProducts.length);
			wishlistContentsContainer.innerHTML = Boolean(fetchedProducts.length) ? productCardsMarkup: noItemText;
			attachClickListeners();
            afterch();

		} else{
		  console.log("Container not found, Wishlist Page element not found");
		}
	});
}

function shopifyHandleize(str) {
  str = str.toLowerCase();

  var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
  
  // For the old browsers
  for (var i = 0; i < toReplace.length; ++i) {
      str = str.replace(toReplace[i], "");
  }

  str = str.replace(/\W+/g, "-");

  if (str.charAt(str.length - 1) == "-") {
      str = str.replace(/-+\z/, "");
  }

  if (str.charAt(0) == "-") {
      str = str.replace(/\A-+/, "");
  }

  return str
};

async function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	// console.log(await checkCartInItem(variantId));
	if (await checkCartInItem(variantId)) {
		console.log("this item is already in cart");
		//console.log(e.target);
		//console.log(e.target.nextElementSibling);
		e.target.nextElementSibling.style.display = "block";
	} else {
		// 追加処理
		e.target.innerHTML = "追加中..";
		window._swat.replayAddToCart({
			empi: productId,
			du: du
		}, variantId, function(c) {
			e.target.innerHTML = "追加済み";
			e.target.setAttribute("data-state-cart", "swym-added");
			console.log("Successfully added product to cart.", c);
		}, function(e) {
			console.log(e);
		});
	}
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	console.log("Events attached!");
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi) {
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}

async function checkCartInItem(addedItemVariantId) {
	let isInCart = false;
	return await fetch("/cart.js")
		.then((response) => response.json())
		.then((data) => {
			// console.log(data);
			for (const item of data.items) {
        if (`${item.variant_id}` === `${addedItemVariantId}`) {
          isInCart = true;
        }
      }
			// console.log(isInCart);
			return isInCart; // return Promise object
		})
		.catch(error => console.error("Error", error))
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */
